import { API, getRequest, postRequest } from 'utils/request';

const defaultConfig = {
  site: '',
  user: '',
  visualsList: [],
  _id: 'visualsConfiguration',
};

export const getConfig = async (callback: any) => {
  let results = {};
  try {
    const res: any = await getRequest(`${API.visualConfig}`);
    results = res.data || { config: defaultConfig };
  } catch (err) {
    console.log(err);
  }
  callback(results);
};

export const postConfig = async (updatedConfig: any, callback: any) => {
  let results = false;
  try {
    // remove the thumbnailURL
    const { config = {} } = updatedConfig;
    const visualsList = (config?.visualsList || []).map((v: any) => {
      return {
        ...v,
        thumbnailUrl: undefined,
      };
    });
    const res: any = await postRequest(`${API.visualConfig}`, {
      config: { ...config, visualsList },
    });
    results = res.data.status || false;
  } catch (err) {
    console.log(err);
  }
  callback(results);
};
